import { useRouter } from 'next/router'
import { useCallback } from 'react'
import { readShellDisabled } from './is-shell-disabled'

interface WithoutShellMessage {
  type: string
  source?: string
  payload?: Record<string, any>
}

interface UseShellGateReturn {
  isShellDisabled: boolean
  sendMessage: (message: WithoutShellMessage) => void
}

export const useShellGate = (): UseShellGateReturn => {
  const { query } = useRouter()
  const shellDisabledQuery = Array.isArray(query.shellDisabled)
    ? query.shellDisabled[0]
    : query.shellDisabled

  const isShellDisabled = readShellDisabled(
    typeof shellDisabledQuery === 'string'
      ? { search: `?shellDisabled=${shellDisabledQuery}` }
      : {}
  )

  const sendMessage = useCallback((message: WithoutShellMessage) => {
    // eslint-disable-next-line no-console
    console.log('[useShellGate] sending message', message)

    window.parent.postMessage(
      {
        type: message.type,
        source: message.source,
        ...message.payload
      },
      '*'
    )
  }, [])

  return {
    isShellDisabled,
    sendMessage
  }
}
